<template>
  <div class="not-login-chat-content-inner">
    <div class="not-login-chat-content-list">
      <div class="not-login-chat-content-list-item">
        {{ current_t['pageTip'] }}
      </div>
      <div class="not-login-chat-content-list-item">
        {{ current_t['or'] }}
        <span class="not-login-chat-content-list-item-link" @click="goToSignIn(ActionType.Login)">{{ current_t['login'] }}</span>
        {{ current_t['continue'] }} >
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { wsLangSetting } from "@/composables/use-ws-lang";
import { ActionType } from '@/components/sign-in/constant'
import { messages } from './contants'

const emit = defineEmits(['sign-in'])


const wsSetting = wsLangSetting();
wsSetting.init();
const { wsLocaleLang } = wsSetting;

const messageObj = messages

const current_t = computed(() => {
  return messageObj[wsLocaleLang.value?.short] || messageObj['en']
})


const goToSignIn = (actionType: ActionType) => {
  emit('sign-in', actionType)
}


</script>

<style scoped lang="scss">

.not-login-chat-content-list {
  font-size: 14px;
  padding: 0 14px;
  margin-top: 10px;
}
.not-login-chat-content-list-item-link {
  color: #141BFF;
  cursor: pointer;
}
</style>